import { lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';

import { paths } from '../paths';
import Banners from 'src/modules/banners/banners/banners';
import BannerDetails from 'src/modules/banners/banner-details/banner-details';
import Adms from 'src/modules/users/adms/adms';
import Shopkeepers from 'src/modules/users/shopkeepers/shopkeepers';
import ShopkeeperDetails from 'src/modules/users/shopkeeper-details/shopkeeper-details';
import AdmDetails from 'src/modules/users/adm-details/adm-details';
import PromotionsList from 'src/modules/benefits/promotions-list/promotions-list';
import PromotionDetails from 'src/modules/benefits/promotion-details/promotion-details';
// import CouponsList from 'src/modules/benefits/coupons-list/coupons-list';
// import CouponDetails from 'src/modules/benefits/coupon-details/coupon-details';
import EventsList from 'src/modules/benefits/events-list/events-list';
import EventDetails from 'src/modules/benefits/events-details/event-details';
import CategoryDetails from 'src/modules/benefits/category-details/category-details';
import ThemeDetails from 'src/modules/benefits/theme-details/theme-details';
import ThemesCategoriesList from 'src/modules/benefits/themes-categories-list/themes-categories-list';
import Faq from 'src/modules/personalization/faq/list/faq';
import FaqDetails from 'src/modules/personalization/faq/details/faq-details';
import ConfigurationsPage from 'src/modules/configurations/configurations';
import MissionsList from 'src/modules/missions/missions-list/missions-list';
import MissionDetails from 'src/modules/missions/mission-details/mission-details';
import FairList from 'src/modules/benefits/fair-list/fair-list';
import FairDetails from 'src/modules/benefits/fair-details/fair-details';
import OnboardingDetails from 'src/modules/personalization/onboarding/onboarding-details';
import HomeBands from 'src/modules/personalization/home-band/list/home-bands';
import HomeBandDetails from 'src/modules/personalization/home-band/details/home-bands';
import HomeBanners from 'src/modules/personalization/home-banner/list/home-banners';
import HomeBannersDetails from 'src/modules/personalization/home-banner/details/home-banners';
import ScnEventsList from 'src/modules/benefits/scn-events-list/scn-events-list';
import ScnEventsDetails from 'src/modules/benefits/scn-events-details/scn-events-details';
import BenefitsDetails from 'src/modules/benefits/benefits-details/benefits-details';

import LpEventsDetails from 'src/modules/benefits/lp-events-details/lp-events-details';
import CollectionsList from 'src/modules/benefits/collections-list/collections-list';
import CollectionsDetails from 'src/modules/benefits/collections-details/collections-details';
import CollectiblesDetails from 'src/modules/benefits/collectibles-details/collectibles-details';
import LpEventsList from 'src/modules/lp-events/events-lp-list/events-lp-list';
import LPBenefitsList from 'src/modules/lp-events/benefits-lp-list/benefits-lp-list';
import LPBenefitDetails from 'src/modules/lp-events/benefit-lp-details/benefit-lp-details';
import LPCouponDetails from 'src/modules/lp-events/coupon-lp-details/coupon-lp-details';
import LPProductDetails from 'src/modules/lp-events/product-lp-details/product-lp-details';
import PromoterTerms from 'src/modules/promoter/promoter-terms/promoter-terms';
import BenefitsList from 'src/modules/benefits/benefits-list/benefits-list';
// ----------------------------------------------------------------------
const AdminPage = lazy(() => import('../factories/admin.factory'));
const PartnersPage = lazy(() => import('../../modules/partners/partners/list/partners'));
const CompaniesPage = lazy(() => import('../../modules/partners/companies/list/companies'));
const RedeemsPage = lazy(() => import('../../modules/partners/redeems/redeems'));
const PartnersDetailsPage = lazy(
  () => import('../../modules/partners/partners/details/partners-details')
);
const CompanyDetailsPage = lazy(
  () => import('../../modules/partners/companies/details/companies-details')
);
const LoginPage = lazy(() => import('../../modules/login/init/login'));
const PageOne = lazy(() => import('../../modules/first/page-one/PageOne'));
const TransactionsPage = lazy(
  () => import('../../modules/transactions/transactions/list/transactions')
);
// const ProductsPage = lazy(() => import('../../modules/benefits/products/list/products'));
const CreditPage = lazy(() => import('../../modules/credit/credit/credit'));
// const ProductDetails = lazy(
//   () => import('../../modules/benefits/products/details/product-details')
// );
const TransactionDetailsPage = lazy(
  () => import('../../modules/transactions/transactions/details/transaction-details')
);
const ConciliationPage = lazy(
  () => import('../../modules/transactions/conciliation/list/conciliation')
);
const AppTextsPage = lazy(() => import('../../modules/personalization/app-texts/list/app-texts'));
const AppTextDetails = lazy(
  () => import('../../modules/personalization/app-texts/details/app-text-details')
);
const AppTermsPage = lazy(
  () => import('../../modules/personalization/app-terms/details/app-terms')
);
const RegulationsPage = lazy(() => import('../../modules/personalization/regulations/regulations'));
const PromotionalRegulationsPage = lazy(
  () => import('../../modules/personalization/regulations/promotional/list/promotional-list')
);
const PromotionalRegulationDetailsPage = lazy(
  () => import('../../modules/personalization/regulations/promotional/details/promotional-details')
);
const ClientsListPage = lazy(() => import('../../modules/users/clients/clients'));
const ClientDetailsPage = lazy(() => import('../../modules/users/clients-details/client-details'));
const PromotersPage = lazy(() => import('../../modules/promoter/promoters/promoters'));
const PromotersDetailsPage = lazy(
  () => import('../../modules/promoter/promoters-details/promoters-details')
);
const LpPromoterList = lazy(() => import('../../modules/lp-events/lp-promoters/lp-promoters'));
const LpPromoterDetails = lazy(
  () => import('../../modules/lp-events/lp-promoter-details/lp-promoter-details')
);
const LpParticipants = lazy(
  () => import('../../modules/lp-events/lp-participants/lp-participants')
);
const LpParticipantDetails = lazy(
  () => import('../../modules/lp-events/lp-participant-details/lp-participant-details')
);
const LPBanners = lazy(() => import('../../modules/lp-events/lp-banners-list/banners-lp-list'));
const LPBannerDetails = lazy(
  () => import('../../modules/lp-events/lp-banner-details/banner-lp-details')
);
const TrailsPage = lazy(() => import('../../modules/trails/trails/trails'));
const TrailDetailsPage = lazy(() => import('../../modules/trails/trails/trail-details'));
const SeasonsPage = lazy(() => import('../../modules/trails/seasons/seasons'));
const SeasonDetailsPage = lazy(() => import('../../modules/trails/seasons/season-details'));

// ----------------------------------------------------------------------
export default function Router() {
  return useRoutes([
    {
      path: paths.dashboard.root,
      element: <AdminPage />,
      children: [
        {
          path: paths.dashboard.initial,
          element: <PageOne />,
        },
        {
          path: paths.dashboard.partners,
          element: <PartnersPage />,
        },
        {
          path: paths.dashboard.banners,
          element: <Banners />,
        },
        {
          path: paths.dashboard.companies,
          element: <CompaniesPage />,
        },
        {
          path: paths.dashboard.redeems,
          element: <RedeemsPage />,
        },
        {
          path: paths.dashboard.createPartnes,
          element: <PartnersDetailsPage />,
        },
        {
          path: paths.dashboard.createCompanies,
          element: <CompanyDetailsPage />,
        },
        {
          path: paths.dashboard.bannerDetails(':id'),
          element: <BannerDetails />,
        },
        {
          path: paths.dashboard.admsList,
          element: <Adms />,
        },
        {
          path: paths.dashboard.admEdit(':id'),
          element: <AdmDetails />,
        },
        {
          path: paths.dashboard.admCreate,
          element: <AdmDetails />,
        },
        {
          path: paths.dashboard.partnerDetails(':id'),
          element: <PartnersDetailsPage />,
        },
        {
          path: paths.dashboard.companyDetails(':id'),
          element: <CompanyDetailsPage />,
        },
        {
          path: paths.dashboard.shopkeepersList,
          element: <Shopkeepers />,
        },
        {
          path: paths.dashboard.shopkeeperDetails(':id'),
          element: <ShopkeeperDetails />,
        },
        {
          path: paths.dashboard.shopkeeperCreate,
          element: <ShopkeeperDetails />,
        },
        {
          path: paths.dashboard.transactions,
          element: <TransactionsPage />,
        },
        {
          path: paths.dashboard.promotionsList,
          element: <PromotionsList />,
        },
        {
          path: paths.dashboard.promotionDetails(':id'),
          element: <PromotionDetails />,
        },
        {
          path: paths.dashboard.promotionCreate,
          element: <PromotionDetails />,
        },
        {
          path: paths.dashboard.credit,
          element: <CreditPage />,
        },
        // {
        //   path: paths.dashboard.couponsList,
        //   element: <CouponsList />,
        // },
        {
          path: paths.dashboard.benefitsList,
          element: <BenefitsList />,
        },
        {
          path: paths.dashboard.benefitsDetails,
          element: <BenefitsDetails />,
        },
        {
          path: paths.dashboard.benefitsDetailsEdit(':id'),
          element: <BenefitsDetails />,
        },
        {
          path: paths.dashboard.transactionCreate,
          element: <TransactionDetailsPage />,
        },
        {
          path: paths.dashboard.transactionEdit(':id'),
          element: <TransactionDetailsPage />,
        },
        {
          path: paths.dashboard.conciliations,
          element: <ConciliationPage />,
        },
        {
          path: paths.dashboard.eventsList,
          element: <EventsList />,
        },
        {
          path: paths.dashboard.eventDetails(':id'),
          element: <EventDetails />,
        },
        {
          path: paths.dashboard.eventCreate,
          element: <EventDetails />,
        },
        {
          path: paths.dashboard.personalizationList,
          element: <AppTextsPage />,
        },
        {
          path: paths.dashboard.personalizationDetails(':id'),
          element: <AppTextDetails />,
        },
        {
          path: paths.dashboard.appTerms,
          element: <AppTermsPage />,
        },
        {
          path: paths.dashboard.regulations,
          element: <RegulationsPage />,
        },
        {
          path: paths.dashboard.promotionalRegulations,
          element: <PromotionalRegulationsPage />,
        },
        {
          path: paths.dashboard.promotionalRegulationsCreate,
          element: <PromotionalRegulationDetailsPage />,
        },
        {
          path: paths.dashboard.promotionalRegulationsCreate,
          element: <PromotionalRegulationDetailsPage />,
        },
        {
          path: paths.dashboard.promotionalRegulationsEdit(':id'),
          element: <PromotionalRegulationDetailsPage />,
        },
        {
          path: paths.dashboard.clients,
          element: <ClientsListPage />,
        },
        {
          path: paths.dashboard.clientDetails(':id'),
          element: <ClientDetailsPage />,
        },
        {
          path: paths.dashboard.promotersList,
          element: <PromotersPage />,
        },
        {
          path: paths.dashboard.promotersEdit(':id'),
          element: <PromotersDetailsPage />,
        },
        {
          path: paths.dashboard.promotersCreate,
          element: <PromotersDetailsPage />,
        },
        {
          path: paths.dashboard.promoterTermsList,
          element: <PromoterTerms />,
        },
        {
          path: paths.dashboard.themesCategoriesList,
          element: <ThemesCategoriesList />,
        },
        {
          path: paths.dashboard.categoryList,
          element: (
            <Navigate to={`${paths.dashboard.themesCategoriesList}?tab=categories`} replace />
          ),
        },
        {
          path: paths.dashboard.categoryDetails(':id'),
          element: <CategoryDetails />,
        },
        {
          path: paths.dashboard.categoryCreate,
          element: <CategoryDetails />,
        },
        {
          path: paths.dashboard.themeList,
          element: <Navigate to={`${paths.dashboard.themesCategoriesList}?tab=themes`} replace />,
        },
        {
          path: paths.dashboard.themeDetails(':id'),
          element: <ThemeDetails />,
        },
        {
          path: paths.dashboard.themeCreate,
          element: <ThemeDetails />,
        },
        {
          path: paths.dashboard.collectionsList,
          element: <CollectionsList />,
        },
        {
          path: paths.dashboard.collectionsDetails(':id'),
          element: <CollectionsDetails />,
        },
        {
          path: paths.dashboard.collectionsCreate,
          element: <CollectionsDetails />,
        },
        {
          path: paths.dashboard.collectibleCreate,
          element: <CollectiblesDetails />,
        },
        {
          path: paths.dashboard.collectibleDetails(':id'),
          element: <CollectiblesDetails />,
        },
        {
          path: paths.dashboard.faq,
          element: <Faq />,
        },
        {
          path: paths.dashboard.faqCreate,
          element: <FaqDetails />,
        },
        {
          path: paths.dashboard.faqDetails(':id'),
          element: <FaqDetails />,
        },
        {
          path: paths.dashboard.configurations,
          element: <ConfigurationsPage />,
        },
        {
          path: paths.dashboard.missionsPage,
          element: <MissionsList />,
        },
        {
          path: paths.dashboard.missionDetails(':id'),
          element: <MissionDetails />,
        },
        {
          path: paths.dashboard.missionCreate,
          element: <MissionDetails />,
        },
        {
          path: paths.dashboard.fairList,
          element: <FairList />,
        },
        {
          path: paths.dashboard.fairDetails(':id'),
          element: <FairDetails />,
        },
        {
          path: paths.dashboard.fairCreate,
          element: <FairDetails />,
        },
        {
          path: paths.dashboard.scnEventsList,
          element: <ScnEventsList />,
        },
        {
          path: paths.dashboard.scnEventDetails(':id'),
          element: <ScnEventsDetails />,
        },
        {
          path: paths.dashboard.scnEventCreate,
          element: <ScnEventsDetails />,
        },
        {
          path: paths.dashboard.lpEventsList,
          element: <LpEventsList />,
        },
        {
          path: paths.dashboard.lpEventDetails(':id'),
          element: <LpEventsDetails />,
        },
        {
          path: paths.dashboard.lpEventCreate,
          element: <LpEventsDetails />,
        },
        {
          path: paths.dashboard.lpEventClone(':id'),
          element: <LpEventsDetails />,
        },
        {
          path: paths.dashboard.onboarding,
          element: <OnboardingDetails />,
        },
        {
          path: paths.dashboard.homeBand,
          element: <HomeBands />,
        },
        {
          path: paths.dashboard.homeBandCreate,
          element: <HomeBandDetails />,
        },
        {
          path: paths.dashboard.homeBandDetails(':id'),
          element: <HomeBandDetails />,
        },
        {
          path: paths.dashboard.homeBanner,
          element: <HomeBanners />,
        },
        {
          path: paths.dashboard.homeBannerCreate,
          element: <HomeBannersDetails />,
        },
        {
          path: paths.dashboard.homeBannerDetails(':id'),
          element: <HomeBannersDetails />,
        },
        {
          path: paths.dashboard.lpBenefitsList,
          element: <LPBenefitsList />,
        },
        {
          path: paths.dashboard.lpBenefitCreate,
          element: <LPBenefitDetails />,
        },
        {
          path: '/admin/lp-events/benefits/edit/:id',
          element: <LPBenefitDetails />,
        },
        {
          path: paths.dashboard.lpCouponsList,
          element: <Navigate to={paths.dashboard.lpBenefitsList} replace />,
        },
        {
          path: paths.dashboard.lpCouponDetails(':id'),
          element: <LPCouponDetails />,
        },
        {
          path: paths.dashboard.lpCouponCreate,
          element: <LPCouponDetails />,
        },
        {
          path: paths.dashboard.lpProductsList,
          element: <Navigate to={paths.dashboard.lpBenefitsList} replace />,
        },
        {
          path: paths.dashboard.lpProductDetails(':id'),
          element: <LPProductDetails />,
        },
        {
          path: paths.dashboard.lpProductCreate,
          element: <LPProductDetails />,
        },
        {
          path: paths.dashboard.lpEventsPromoters,
          element: <LpPromoterList />,
        },
        {
          path: paths.dashboard.lpEventsPromoterCreate,
          element: <LpPromoterDetails />,
        },
        {
          path: paths.dashboard.lpEventsPromoterDetails(':id'),
          element: <LpPromoterDetails />,
        },
        {
          path: paths.dashboard.lpEventsParticipants,
          element: <LpParticipants />,
        },
        {
          path: paths.dashboard.lpEventsParticipantCreate,
          element: <LpParticipantDetails />,
        },
        {
          path: paths.dashboard.lpEventsParticipantDetails(':id'),
          element: <LpParticipantDetails />,
        },
        {
          path: paths.dashboard.lpEventsBanners,
          element: <LPBanners />,
        },
        {
          path: paths.dashboard.lpEventsBannerCreate,
          element: <LPBannerDetails />,
        },
        {
          path: paths.dashboard.lpEventsBannerDetails(':id'),
          element: <LPBannerDetails />,
        },
        {
          path: paths.dashboard.trails,
          element: <TrailsPage />,
        },
        {
          path: paths.dashboard.trailCreate,
          element: <TrailDetailsPage />,
        },
        {
          path: paths.dashboard.trailDetails(':id'),
          element: <TrailDetailsPage />,
        },
        {
          path: paths.dashboard.seasons,
          element: <SeasonsPage />,
        },
        {
          path: paths.dashboard.seasonCreate,
          element: <SeasonDetailsPage />,
        },
        {
          path: paths.dashboard.seasonDetails(':id'),
          element: <SeasonDetailsPage />,
        },
      ],
    },
    { path: paths.unknown, element: <Navigate to={paths.dashboard.root} replace /> },
    { path: paths.root, element: <Navigate to={paths.dashboard.root} replace /> },
    { path: paths.auth.login, element: <LoginPage /> },
  ]);
}
